import React, { useCallback, useEffect, useRef, useState } from "react";
import "../../assets/styles/local/header.css";
import "../../assets/styles/local/contactlist.css";
import { useDispatch, useSelector } from "react-redux";
import { API_URL } from "../../redux/constants/type";
import { axiosInstance as axios } from "../../redux/constants/axiosInstance";
import { Image, Row, Col } from "react-bootstrap";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { BiUnlink } from "react-icons/bi";
import { AiFillPlusCircle } from "react-icons/ai";
import {
  FetchContactsByCompanyid,
  DeleteContacts,
  CreateUnlinkContact,
  RemoveDocsClientById,
  AddComments,
  EmptyProductPart,
  GlobalRequest,
} from "../../redux/actions/action";

import Modal from "react-bootstrap/Modal";
import { BsChevronDown } from "react-icons/bs";
import ReactPaginate from "react-paginate";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import smaliIcon from "../../assets/icons/meh.svg";
import AddIcon from "../..//assets/icons/addicon.svg";
import orderPickingFilter from "../../assets/icons/orderPickingFilter.svg";
import Image1 from "../..//assets/icons/Group 507.svg";
import Image2 from "../..//assets/icons/Group 511.svg";
import Image3 from "../..//assets/icons/Group 514.svg";
import Image4 from "../..//assets/icons/Union112.svg";
import Image5 from "../..//assets/icons/Group 1277.svg";
import Kebab from "../..//assets/icons/Kebab contacts.svg";
import Bin from "../..//assets/icons/Bin.svg";
import Conthover from "../..//assets/icons/Contacthover.svg";
import search from "../../assets/icons/search.svg";
import Header from "../../layouts/Header";
import Loader from "../../components/Dailogs/Loader";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import LogoSmall from "../../assets/images/logo-small.png";
import AddTaskModal from "../../components/Dailogs/AddTaskModal";
import moment from "moment";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const ContactList = () => {
  const [query, setQuery] = useState("");
  const history = useHistory();
  const selectDoc2 = useRef(null);
  const ViewBy_Popup_Ref = useRef(null);
  const filter_Popup_Ref = useRef(null);

  const userid = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");
  const packageID = window.localStorage.getItem("packageId");
  const companyId = window.localStorage.getItem("companyid");

  const [showMemberItem, setShowMemberItem] = useState(false);
  const [contactlist, setContactlist] = useState([]);
  // const [perPage, setPerPage] = useState(
  //   window.localStorage.getItem("cl-pp") || 10
  // );
  const [perPage, setPerPage] = useState(
    10 || window.localStorage.getItem("cl-pp"),
  );
  const [hovereff, setHovereff] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [rotate, setRotate] = useState();
  const [fulLenghtEmail, setFulLenghtEmail] = useState(false);
  const [emailI, setEmailI] = useState();
  const [modal, showModal] = useState(false);
  const [isDeletedContact, setIsDeletedContact] = useState(false);
  const [deleteUser, setDeleteUser] = useState("");
  const [unlinkContact, setUlnlinkContact] = useState("");
  const [finalContact, setFinalContact] = useState("");
  const [contactID, setContactID] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [showLoader, setShowLoader] = useState(true);

  const dispatch = useDispatch();
  const companyid = window.localStorage.getItem("companyid");
  const languages = window.localStorage.getItem("language");

  const getTaskStatusListRes = useSelector(
    (state) => state.user.getTaskStatusListRes,
  );

  const FetchCompanyData = useSelector(
    (state) => state.user.FetchContactsByCompanyid,
  );
  const DeleteContactsFetchData = useSelector(
    (state) => state.user.DeleteContactsdata,
  );
  const UnlinkedContactsFetchData = useSelector(
    (state) => state.user.CreateUnlinkContactdata,
  );

  const [fetchTransContactList, setFetchTransContactList] = useState({});
  const t = (key) => fetchTransContactList?.[key] || "";

  const [isBasicMember, setIsBasicMember] = useState(false);
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      const isBasicPlan = getAppSideNavOptions.every(
        (x) =>
          x.packageName.toUpperCase() == "BASIC" &&
          x.packageId == process.env.REACT_APP_IS_BASIC,
      );
      setIsBasicMember(isBasicPlan);

      const isBuildingBlockVal = getAppSideNavOptions.every(
        (x) => x.packageId == process.env.REACT_APP_IS_PREMIUM,
      );
      setIsBuildingBlock(isBuildingBlockVal);
    }
  }, [getAppSideNavOptions]);

  useEffect(() => {
    fetchScreenTranslations("Contacts-List").then((res) => {
      setFetchTransContactList(res);
    });
  }, []);

  const fetchContactList = useCallback(
    (perPage, query, currentPage, filterValue) => {
      dispatch(
        FetchContactsByCompanyid(
          companyid,
          currentPage + 1,
          query,
          perPage,
          filterValue,
        ),
      );
    },
    [],
  );

  useEffect(() => {
    fetchContactList(perPage, query, currentPage, filterValue);
  }, []);

  useEffect(() => {
    if (FetchCompanyData != null) {
      if (FetchCompanyData?.data?.status === true) {
        setContactlist(FetchCompanyData?.data);
        preparePagination(FetchCompanyData?.data?.totalCount);
        setTimeout(() => {
          setShowLoader(false);
        }, 1000);
      }
    }
  }, [FetchCompanyData]);

  useEffect(() => {
    if (DeleteContactsFetchData?.status === 200) {
      fetchContactList(perPage, query, currentPage);
    }
  }, [DeleteContactsFetchData]);

  useEffect(() => {
    if (isDeletedContact === true) {
      setTimeout(() => {
        fetchContactList(perPage, query, currentPage);
        setIsDeletedContact(false);
      }, 1000);
    }
  }, [isDeletedContact]);

  useEffect(() => {
    if (UnlinkedContactsFetchData?.status === 200) {
      fetchContactList(perPage, query, currentPage);
    }
  }, [UnlinkedContactsFetchData]);

  const isSearched = useRef(false);
  useEffect(() => {
    if (query) {
      isSearched.current = true;
      setCurrentPage(0);
      fetchContactList(perPage, query, 0);
    } else {
      if (isSearched.current) {
        isSearched.current = false;
        setCurrentPage(0);
        fetchContactList(perPage, query, 0);
      }
    }
  }, [query]);

  const preparePagination = (totalRecords) => {
    const totalPages = Math.ceil(totalRecords / perPage);
    setTotalPages(totalPages);
  };

  const PaginationChange = (event) => {
    setCurrentPage(event.selected);
    fetchContactList(perPage, query, event.selected);
  };

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    // setFinalContact("");
    setContactID("");
  };

  const hendleClick = () => {
    selectDoc2.current.click();
  };

  const docUpload3 = async (e, finalContact) => {
    const target = e.target.files[0];
    var formData = new FormData();
    formData.append("", target);
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response !== null) {
        setTimeout(() => {
          axios({
            method: "post",
            url: `${API_URL}/api/Files/Adddocumenttocontact`,
            headers: {
              "Content-Type": "application/json",
              "contact-id": finalContact,
              "session-id": window.localStorage.getItem("session-id"),
            },
            data: {
              contactid: finalContact,
              userid: userid,
              docs: [
                {
                  documentname: e.target.files[0].name,
                  documentextension: e.target.files[0].type,
                  documentcontent: "string",
                  link: response.data[0],
                  documentsize: e.target.files[0].size,
                },
              ],
            },
          }).then((response) => {
            if (response?.data?.status === true) {
              setAnchorEl(null);
              window.localStorage.setItem("Doc", "Doc");
              window.localStorage.removeItem("clientaddname");
              history.push(`/contactlist/edit-contact/${finalContact}`);
            }
          });
        }, 1000);
        handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: "Document Uploaded successfully!",
          },
          false,
        );
      }
    } catch (error) {}
  };

  useEffect(() => {
    document.addEventListener(
      "click",
      () => {
        setRotate();
      },
      true,
    );
    return () => {
      document.removeEventListener("click", setRotate(), true);
    };
  }, []);

  const refTypeDropDownContainer = useRef();
  const handleMouseDowTypeDD = (event) => {
    if (
      refTypeDropDownContainer.current &&
      !refTypeDropDownContainer.current.contains(event.target)
    ) {
      setShowMemberItem(false);
    }
  };
  useEffect(() => {
    if (showMemberItem) {
      window.addEventListener("mousedown", handleMouseDowTypeDD);
    } else {
      window.addEventListener("mousedown", handleMouseDowTypeDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDowTypeDD);
    };
  }, [showMemberItem]);

  const getNameAbbrivation = (firstname, lastname) => {
    const fullName = `${firstname} ${lastname}`;
    if (fullName) {
      const arr = fullName.split(" ").filter((x) => Boolean(x));
      arr.forEach((x) => {
        return x.trim();
      });
      if (arr.length > 0) {
        if (arr.length === 1) {
          return arr[0].slice(0, 2)?.toUpperCase();
        } else if (arr.length > 1) {
          return `${arr[0].slice(0, 1)?.toUpperCase()}${arr[1]
            .slice(0, 1)
            ?.toUpperCase()}`;
        }
      }
    }
  };

  const handleContactAssignTask = () => {
    setAddTaskModal(true);
    handleClose();
  };

  const handleFileChange22 = (e) => {
    const target = e.target.files[0];
    let formData = new FormData();
    formData.append("file", target);
    axios
      .put(`${API_URL}/api/Files/UploadToS3`, formData)
      .then(function (response) {
        if (response !== null) {
          setImgUrl(response.data[0]);
        }
      })
      .catch(function (error) {});
  };

  const handleFileChange = (data) => {
    setImgUrl(data.link);
    // setAttachMessage(`${data.name} File is Attached in comment box`);
  };

  const [addTaskModal, setAddTaskModal] = useState(false);
  const [enablecomm, setEnableComm] = useState(false);
  const [showcmnt, setShowcmnt] = useState(true);
  const [message, setMessage] = useState("");
  const [length, setLength] = useState("");
  const [imgUrl, setImgUrl] = useState("");

  const isValidActivityLog = (log) => {
    if (log.affectedColumns) {
      if (
        log.affectedColumns.length === 1 &&
        log.affectedColumns[0] === "Updatedat"
      ) {
        return false;
      }
    }
    return true;
  };

  const getActivityLog = (activity = []) => {
    const activityLogs = activity;
    let returnValue = "";
    activityLogs.every((log, index) => {
      switch (log.type) {
        case "Create":
          if (log.tableName === "Contacts") {
            if (log.newValues.Relationship) {
              returnValue = "Relationship Set";
            }
            returnValue = "Contact Created";
          }
          if (log.tableName === "Documents") {
            returnValue = "Document Attached";
          }
          if (log.tableName === "Contacttasks") {
            returnValue = "Task Assigned";
          }
          break;
        case "Update":
          if (log.tableName === "Contacts" && isValidActivityLog(log)) {
            if (log.newValues.Relationship) {
              returnValue = "Relationship Set";
            }
            returnValue = "Contact Updated";
          }
          if (log.tableName === "Tasks") {
            returnValue = "Task Updated";
          }
          if (log.tableName === "Clients") {
            if (log.newValues.Priceagreement) {
              returnValue = "Rate Assigned";
            }
          }
          break;
        case "Delete":
          if (log.tableName === "Tasks") {
            returnValue = "Task Deleted";
          }
          if (log.tableName === "Documents") {
            returnValue = "Document Deleted";
          }
          break;
        default:
          break;
      }
      return returnValue == "";
    });
    return returnValue;
  };
  const TaskId = window.localStorage.getItem("taskid");
  const userId = window.localStorage.getItem("userid");
  const [taskid, setTaskid] = useState("");
  const [contactname3, setContactname3] = useState(false);
  const [comments, setComments] = useState([]);
  const [maxComments, setMaxComments] = useState([]);
  const [taggedUser, setTaggedUser] = useState([]);
  const [minComments, setMinComments] = useState([]);
  const [val, setVal] = useState("");
  const [popups, setPopups] = useState(false);
  const [show, setShow] = useState([]);
  const initialRender5 = React.useRef(true);
  React.useEffect(() => {
    if (!initialRender5.current) {
      if (comments != null) {
        if (comments.status == true) {
          setMinComments([]);
          setShow(comments.data);
          setLength(comments.data.length);
          for (var i = 0; i < 5; i++) {
            minComments.push(comments.data[i]);
          }
          setMaxComments(minComments.filter((item) => item != undefined));
        } else {
        }
      }
    } else {
      initialRender5.current = false;
    }
  }, [comments]);
  const fetchComments = async (taskId) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchComments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        relatedtoid: taskId,
        type: "task",
      },
    }).then((response) => {
      setComments(response.data);
    });
  };
  useEffect(() => {
    if (taskid) {
      fetchComments(taskid);
    }
  }, [taskid]);

  useEffect(() => {
    if (TaskId) {
      // setReRenderAPI(true);
      // setShowModal(true);
      setTaskid(TaskId);
      // setModalFunctionNoty("Notification");
      // setModalFunction("Notification");
    }
    setTimeout(() => {
      window.localStorage.removeItem("taskid");
    }, 5000);

    return () => {
      window.localStorage.removeItem("taskid");
    };
  }, []);

  const handleAddComments = () => {
    dispatch(AddComments(userid, taskid, message, "task", imgUrl, taggedUser));
    setTimeout(() => {
      fetchComments(taskid);
    }, 1000);
    setTaggedUser([]);
    setMessage("");
    setImgUrl("");
  };

  useEffect(() => {
    dispatch(
      GlobalRequest({
        url: `${API_URL}/api/Stage/GetTaskStatusDropdownList`,
        method: "get",
        state: "getTaskStatusListRes",
        data: {},
      }),
    );
  }, []);

  const [statusList, setStatusList] = useState([]);
  const [showNewTaskSystem, setShowNewTaskSystem] = useState(false);

  useEffect(() => {
    if (companyId === "28830f30-b321-4662-a576-f23451677742")
      return setShowNewTaskSystem(false);
    if (packageID === process.env.REACT_APP_IS_PREMIUM) {
      setShowNewTaskSystem(true);
    }
  }, [packageID, companyId]);

  useEffect(() => {
    if (getTaskStatusListRes?.status === true) {
      setStatusList(getTaskStatusListRes?.data);
    }
  }, [getTaskStatusListRes]);

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      ViewBy_Popup_Ref.current &&
      !ViewBy_Popup_Ref.current.contains(event.target)
    ) {
      setCompanyShow(false);
      setArrowOptionsRotate(false);
    }

    if (
      filter_Popup_Ref.current &&
      !filter_Popup_Ref.current.contains(event.target)
    ) {
      setFiltersPopupShow(false);
    }

    // if (type_an_item_Drop_Ref.current && !type_an_item_Drop_Ref.current.contains(event.target)) {
    //   setShowProductsPeople(false);
    // }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  // view by start.
  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);
  const [companyShow, setCompanyShow] = useState(false);
  const [viewByTxtShow, setViewByTxtShow] = useState("Contact");
  // view by end.

  useEffect(() => {
    setViewByTxtShow(t("Contact"));
  }, [fetchTransContactList]);

  // if we want radio check uncheck then make it only one state //
  const [allFilter, setAllFilter] = useState(true);
  const [clients, setClients] = useState(false);
  const [other, setOthers] = useState(false);
  const [filtersPopupShow, setFiltersPopupShow] = useState(false);

  // asc filter status variables....
  const [allStatus, setAllStatus] = useState("");
  const [sentStatus, setSentStatus] = useState("");
  const [productandPartValue, setProductandPartValue] = useState("");
  const [filterValue, setFilterValue] = useState("");

  useEffect(() => {
    fetchContactList(perPage, query, currentPage, filterValue);
  }, [filterValue]);

  return (
    <>
      {/* <Header setQuery={setQuery} /> */}
      <Header
        setQuery={setQuery}
        leftComponent={
          <div className="d-flex align-items-baseline flex-wrap gap-4 pt-2">
            <div
              className="fw-bold Contact-heading"
              onClick={() => {
                history.push("/contact-list");
              }}
            >
              {/* Contact */}
              {t("Contact")}
            </div>
          </div>
        }
      />

      {addTaskModal && (
        <AddTaskModal
          val={val}
          setVal={setVal}
          showModal={addTaskModal}
          setTaskid={setTaskid}
          popups={popups}
          setPopups={setPopups}
          statusList={statusList}
          showNewTaskSystem={showNewTaskSystem}
          isBasicMember={isBasicMember}
          isBuildingBlock={isBuildingBlock}
          setShowModal={(show, reload) => {
            setAddTaskModal(false);
            if (reload) {
              window.localStorage.setItem("Task", "Task");
              window.localStorage.removeItem("clientaddname");
              history.push(`/contactlist/edit-contact/${finalContact}`);
            }
          }}
          defaultContactId={finalContact}
          setComments={setComments}
          modalFunction={"add"}
          setEnableComm={setEnableComm}
          setShowcmnt={setShowcmnt}
          enablecomm={enablecomm}
          showcmnt={showcmnt}
          setMessage={setMessage}
          message={message}
          handleFileChange={handleFileChange}
          handleAddComments={handleAddComments}
          maxComments={maxComments}
          setMaxComments={setMaxComments}
          show={show}
          setShow={setShow}
          length={length}
          setLength={setLength}
          imgUrl={imgUrl}
          setImgUrl={setImgUrl}
          from={moment().toDate()}
          searchText={""}
          taggedUser={taggedUser}
          setTaggedUser={setTaggedUser}
        />
      )}

      {showLoader === true ? (
        <div
          className="text-center "
          style={{ color: "#003766", fontSize: "14px", fontWeight: "700" }}
        >
          <Loader />
        </div>
      ) : (
        <div className="parent">
          <searchSection>
            {" "}
            {/* search for mobile view */}
            <div className="member_searchShow" style={{ position: "relative" }}>
              <input
                className="member_search_input_input"
                type="text"
                placeholder=""
                value={query}
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
              <img className="member_search_input_icon" src={search} alt="" />
            </div>
          </searchSection>
          <div className="outer">
            <Row className="row-item">
              <Col xl={4} className="p-0">
                <div className="d-flex align-items-baseline">
                  <p className="mt-2 Contact-sub-heading ps-4 ps-lg-2">
                    {/* View by */}
                    {t("View by")}
                  </p>

                  <div
                    ref={ViewBy_Popup_Ref}
                    className="asc_Search_Box w-50 ms-2 d-flex pointer"
                    style={{
                      border: "0.5px solid #e0dada",
                      borderRadius: "8px",
                      background: "white",
                      boxShadow: "unset",
                    }}
                  >
                    <p
                      className="asc_Client_Input_For_Long ps-3"
                      onClick={() => {
                        setCompanyShow(!companyShow);
                        setArrowOptionsRotate(!arrowOptionsRotate);
                      }}
                    >
                      {/* {projectName ? projectName : "Select a Project"} */}
                      <p className="mb-0 selectedTxT">{viewByTxtShow}</p>
                    </p>

                    <img
                      src={DownArrowOption}
                      className={
                        arrowOptionsRotate ? "upArrow mt-1" : "downArrow mt-1"
                      }
                      alt=""
                      onClick={() => {
                        setCompanyShow(!companyShow);
                        setArrowOptionsRotate(!arrowOptionsRotate);
                      }}
                    />

                    {companyShow && (
                      <div
                        className="asc_Custom_Select_Outer pt-1"
                        style={{
                          top: "53px",
                          border: "0.5px solid #e0dada",
                          borderRadius: "8px",
                          background: "white",
                        }}
                      >
                        <div className="">
                          <p
                            className={
                              // viewByTxtShow === "Contact"
                              viewByTxtShow === t("Contact")
                                ? "asc_Selected_Item ps-3 py-1 m-2 d-flex justify-content-between"
                                : "ps-3 py-1 m-2 hoverItem"
                            }
                            style={{ boxShadow: "unset" }}
                            onClick={() => {
                              history.push("/contact-list");
                              // setViewByTxtShow("Contact");
                              setViewByTxtShow(t("Contact"));
                              setCompanyShow(false);
                              setArrowOptionsRotate(false);
                            }}
                          >
                            {/* Contact */}
                            {t("Contact")}
                            {/* {viewByTxtShow === "Contact" && (
                              <p className="mb-0 pe-2">✔</p>
                            )} */}
                            {viewByTxtShow === t("Contact") && (
                              <p className="mb-0 pe-2">✔</p>
                            )}
                          </p>
                          <p
                            className={
                              viewByTxtShow === "Company"
                                ? "asc_Selected_Item ps-3 py-1 m-2 d-flex justify-content-between"
                                : "ps-3 py-1 m-2 hoverItem"
                            }
                            style={{ boxShadow: "unset" }}
                            onClick={() => {
                              history.push("/company-list");
                              // setViewByTxtShow("Company");
                              setViewByTxtShow(t("Company"));
                              setCompanyShow(false);
                              setArrowOptionsRotate(false);
                            }}
                          >
                            {/* Company */}
                            {t("Company")}
                            {/* {viewByTxtShow === "Company" && (
                              <p className="mb-0 pe-2">✔</p>
                            )} */}
                            {viewByTxtShow === t("Company") && (
                              <p className="mb-0 pe-2">✔</p>
                            )}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
              <Col xl={4} className="p-0">
                {/* <p className="mt-2 Contact-sub-heading">Filter</p> */}
                <filterSection
                  className="ps-0 ps-sm-5 pt-3 w-75 d-flex gap-2 filterTexts positionForFilterPopup"
                  ref={filter_Popup_Ref}
                >
                  <p className="ps-0 ps-sm-3">
                    Filters
                    {/* {fetchTransContactList[31]?.translation} */}
                  </p>
                  <img
                    className="mb-4 pt-1 pointer"
                    src={orderPickingFilter}
                    alt=""
                    onClick={() => setFiltersPopupShow(true)}
                  />
                  <div className="d-flex gap-0 ps-2">
                    <p className="allBorder pb-4">{filterValue || "All"}</p>
                    {/* <p className="xIconInvoice px-1 pb-4">x</p> */}
                  </div>

                  {/*ASC filter popup start */}
                  <section
                    className="filterPopup h-auto"
                    style={{
                      transform: filtersPopupShow ? "scale(1)" : "scale(0)",
                      transitionDuration: "300ms",
                    }}
                  >
                    <p
                      className="xCiecle ms-auto me-3 mt-1 pointer"
                      onClick={() => {
                        setFiltersPopupShow(false);
                      }}
                    >
                      x
                    </p>

                    <div className="form-check underTexts">
                      <input
                        className="form-check-input pointer companyRadio"
                        style={{
                          borderRadius: "50%",
                          width: "15px",
                          height: "15px",
                        }}
                        type="checkbox"
                        // value="All"
                        id="ascInvoice2"
                        checked={allFilter}
                        onClick={() => {
                          setAllFilter(!allFilter);
                          setClients(false);
                          setOthers(false);
                          setFilterValue("");
                        }}
                      />
                      <label
                        className="form-check-label pointer"
                        for="ascInvoice2"
                      >
                        <p className="mb-0 fs-6">
                          All
                          {/* {fetchTransContactList[32]?.translation} */}
                        </p>
                      </label>
                    </div>

                    <div className="form-check underTexts">
                      <input
                        className="form-check-input pointer companyRadio"
                        style={{
                          borderRadius: "50%",
                          width: "15px",
                          height: "15px",
                        }}
                        type="checkbox"
                        // value="Sent"
                        id="ascInvoice3"
                        checked={filterValue === "Highest"}
                        onClick={() => {
                          setClients(!clients);
                          setFilterValue("Highest");
                          setAllFilter(false);
                          setOthers(false);
                        }}
                      />
                      <label
                        className="form-check-label pointer"
                        for="ascInvoice3"
                      >
                        <p className="mb-0 fs-6">
                          Highest
                          {/* {fetchTransContactList[33]?.translation} */}
                        </p>
                      </label>
                    </div>

                    <div className="form-check underTexts">
                      <input
                        className="form-check-input pointer companyRadio"
                        style={{
                          borderRadius: "50%",
                          width: "15px",
                          height: "15px",
                        }}
                        type="checkbox"
                        value="Sent"
                        id="ascInvoice5"
                        checked={filterValue === "High"}
                        onClick={() => {
                          setOthers(!other);
                          setFilterValue("High");
                          setAllFilter(false);
                          setClients(false);
                        }}
                      />
                      <label
                        className="form-check-label pointer"
                        for="ascInvoice5"
                      >
                        <p className="mb-0 fs-6">
                          High
                          {/* {fetchTransContactList[34]?.translation} */}
                        </p>
                      </label>
                    </div>

                    <div className="form-check underTexts">
                      <input
                        className="form-check-input pointer companyRadio"
                        style={{
                          borderRadius: "50%",
                          width: "15px",
                          height: "15px",
                        }}
                        type="checkbox"
                        value="Sent"
                        id="ascInvoice6"
                        checked={filterValue === "Low"}
                        onClick={() => {
                          setOthers(!other);
                          setFilterValue("Low");
                          setAllFilter(false);
                          setClients(false);
                        }}
                      />
                      <label
                        className="form-check-label pointer"
                        for="ascInvoice6"
                      >
                        <p className="mb-0 fs-6">
                          Low
                          {/* {fetchTransContactList[34]?.translation} */}
                        </p>
                      </label>
                    </div>

                    <div className="form-check underTexts">
                      <input
                        className="form-check-input pointer companyRadio"
                        style={{
                          borderRadius: "50%",
                          width: "15px",
                          height: "15px",
                        }}
                        type="checkbox"
                        value="Sent"
                        id="ascInvoice7"
                        checked={filterValue === "Medium"}
                        onClick={() => {
                          setOthers(!other);
                          setFilterValue("Medium");
                          setAllFilter(false);
                          setClients(false);
                        }}
                      />
                      <label
                        className="form-check-label pointer"
                        for="ascInvoice7"
                      >
                        <p className="mb-0 fs-6">
                          Medium
                          {/* {fetchTransContactList[34]?.translation} */}
                        </p>
                      </label>
                    </div>

                    <button
                      className="clearButton mx-3 mt-3"
                      onClick={() => {
                        setAllFilter(true);
                        setClients(false);
                        setOthers(false);

                        setSentStatus("");
                        setFilterValue("");
                      }}
                    >
                      Clear
                      {/* {fetchTransContactList[35]?.translation} */}
                    </button>
                  </section>
                  {/*ASC filter popup end */}
                </filterSection>
              </Col>
              <Col xl={4} className="add-col-item pe-0">
                <div
                  onClick={() => {
                    dispatch(RemoveDocsClientById());
                    dispatch(EmptyProductPart());
                    window.localStorage.removeItem("clientaddname");
                    window.localStorage.removeItem("clientId2");
                    window.localStorage.removeItem("_tmpCon");
                    history.push("/add-contact");
                  }}
                  onMouseOver={() => setHovereff(true)}
                  onMouseOut={() => setHovereff(false)}
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "d-none"
                      : "d-flex add-member-btns"
                  }
                  style={{ borderRadius: "12px" }}
                >
                  {hovereff ? (
                    <Image height={17} width={21} src={AddIcon} />
                  ) : (
                    <Image height={17} width={21} src={Conthover} />
                  )}
                  <p className="add-member-text ms-3 mb-0">
                    {t("Add contact")}
                  </p>
                </div>
              </Col>
            </Row>
            <div className="table-responsive mt-2 member-list-dives">
              <table className="table ">
                <thead>
                  <tr
                    className=""
                    style={{
                      color: "#333333",
                      fontSize: "14px",
                      fontWeight: "700",
                      borderBottom: "2px solid #e0e0e0",
                    }}
                  >
                    <th className="pb-1">
                      <p
                        className="ms-4 table-item mt-2"
                        style={{
                          fontWeight: "bold",
                          color: "#333333",
                        }}
                      >
                        {t("Name")}
                      </p>
                    </th>
                    <th className="pb-1 ascHideForMobile">
                      <p
                        className="table-item mt-2"
                        style={{
                          fontWeight: "bold",
                          color: "#333333",
                        }}
                      >
                        {t("Telephone")}
                      </p>
                    </th>
                    <th className="pb-1 ascHideForMobile HideForTablet">
                      <p
                        className="table-item mt-2"
                        style={{
                          fontWeight: "bold",
                          color: "#333333",
                        }}
                      >
                        {t("E-mail")}
                      </p>
                    </th>
                    <th className="pb-1">
                      <p
                        className="table-item mt-2"
                        style={{
                          fontWeight: "bold",
                          color: "#333333",
                        }}
                      >
                        {t("Type")}
                      </p>
                    </th>
                    <th className="pb-1 ascHideForMobile HideForTablet">
                      <p
                        className="table-item mt-2"
                        style={{
                          fontWeight: "bold",
                          color: "#333333",
                        }}
                      >
                        {t("Account Manager")}
                      </p>
                    </th>
                    <th className="ascHideForMobile HideForTablet">
                      <p
                        className="table-item mt-2"
                        style={{
                          fontWeight: "bold",
                          color: "#333333",
                        }}
                      >
                        {t("Last Activity")}
                      </p>
                    </th>
                  </tr>
                </thead>

                <tbody
                  className="tabLine"
                  style={{
                    color: "#333333",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  {contactlist?.data?.map((items, index) => {
                    return (
                      <tr
                        key={`cont-list-${index}`}
                        className="hov_effects position-relative"
                      >
                        <td className="d-flex ms-4 pt-2">
                          {items?.photo !== "" ? (
                            <img
                              alt=""
                              src={items?.photo}
                              className="img-avatar mt-1"
                              height="30px"
                              width="30px"
                            />
                          ) : (
                            <div className="img-avatar text-center mt-1">
                              {getNameAbbrivation(
                                items?.firstname,
                                items?.lastname,
                              )}
                            </div>
                          )}

                          <span className="ps-3 fw-bold">
                            {items?.contactclients &&
                            items.contactclients[0]?.clientname ? (
                              <Link
                                to={`/contactlist/edit-contact/${items?.contactid}`}
                                onClick={() => {
                                  window.localStorage.removeItem(
                                    "clientaddname",
                                  );
                                  window.localStorage.removeItem("clientId2");
                                  window.localStorage.removeItem("_tmpCon");
                                }}
                                className="clientname_hover_upper contact-name-wrapper"
                                style={{
                                  textDecoration: "none",
                                  color: "#333333",
                                }}
                                title={
                                  items.firstname.length +
                                    items.lastname.length >
                                  10
                                    ? `${items.firstname} ${items.lastname}`
                                    : undefined
                                }
                              >
                                {items?.firstname}&nbsp;
                                {items?.lastname}
                              </Link>
                            ) : (
                              <Link
                                to={`/contactlist/edit-contact/${items?.contactid}`}
                                onClick={() => {
                                  window.localStorage.removeItem(
                                    "clientaddname",
                                  );
                                  window.localStorage.removeItem("clientId2");
                                  window.localStorage.removeItem("_tmpCon");
                                }}
                                className="clientname_hover_upper  contact-name-wrapper"
                                style={{
                                  textDecoration: "none",
                                  color: "#333333",
                                  position: "relative",
                                  top: "10px",
                                }}
                              >
                                {items?.firstname}&nbsp;
                                {items?.lastname}
                              </Link>
                            )}
                            <Link
                              onClick={() => {
                                window.localStorage.removeItem("clientaddname");
                                window.localStorage.removeItem("clientId2");
                                window.localStorage.removeItem("_tmpCon");
                              }}
                              // to={
                              //   items?.contactclients
                              //     ? `/contactlist/add-company/${items?.contactclients[0]?.clientid}`
                              //     : ""
                              // }

                              to={
                                items?.contactclients
                                  ? `/add-company/${items?.contactclients[0]?.clientid}`
                                  : ""
                              }
                              style={{
                                textDecoration: "none",
                                color: "#333333",
                              }}
                              className=" contact-name-wrapper"
                            >
                              <p
                                className="clientname_hove"
                                style={{
                                  fontWeight: "400",
                                  fontSize: "12px",
                                }}
                              >
                                {items?.contactclients &&
                                  items?.contactclients[0]?.clientname}
                              </p>
                            </Link>
                          </span>
                        </td>
                        <td className="pt-3 ascHideForMobile HideForTablet">
                          <Link
                            to={`/contactlist/edit-contact/${items?.contactid}`}
                            onClick={() => {
                              window.localStorage.removeItem("clientaddname");
                              window.localStorage.removeItem("clientId2");
                              window.localStorage.removeItem("_tmpCon");
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#333333",
                            }}
                          >
                            {items?.contactphonenumber &&
                              (items?.contactphonenumber[0]?.phonenumber
                                ? "+" +
                                  items?.contactphonenumber[0]?.phonenumber
                                    .slice(0, 2)
                                    ?.toUpperCase() +
                                  " " +
                                  items?.contactphonenumber[0]?.phonenumber
                                    .slice(2)
                                    ?.toUpperCase()
                                : "")}
                          </Link>
                        </td>
                        <td className="pt-3 ascHideForMobile HideForTablet">
                          <Link
                            className="contact-email-wrapper"
                            to={`/contactlist/edit-contact/${items?.contactid}`}
                            onClick={() => {
                              window.localStorage.removeItem("clientaddname");
                              window.localStorage.removeItem("clientId2");
                              window.localStorage.removeItem("_tmpCon");
                            }}
                            onMouseOut={() => {
                              setFulLenghtEmail(false);
                              setEmailI("");
                            }}
                            onMouseOver={() => {
                              if (
                                items?.contactemail &&
                                items?.contactemail[0]?.email?.length > 22
                              ) {
                                setFulLenghtEmail(true);
                                setEmailI(index);
                              }
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#333333",
                            }}
                          >
                            <div
                              className="truncated-text"
                              style={{
                                textAlign: "left",
                              }}
                            >
                              {items?.contactemail?.[0]?.email &&
                                `${items?.contactemail[0]?.email.slice(0, 22)}${
                                  items?.contactemail[0]?.email?.length > 22
                                    ? "..."
                                    : ""
                                }`}
                            </div>
                            {fulLenghtEmail && emailI === index && (
                              <div
                                className="email-hover-stat p-2"
                                style={{
                                  position: "absolute",
                                  top: " 10px",
                                }}
                              >
                                {items?.contactemail &&
                                  items?.contactemail[0]?.email}
                              </div>
                            )}
                          </Link>
                        </td>
                        <td className="pt-3">
                          <Link
                            to={`/contactlist/edit-contact/${items?.contactid}`}
                            onClick={() => {
                              window.localStorage.removeItem("clientaddname");
                              window.localStorage.removeItem("clientId2");
                              window.localStorage.removeItem("_tmpCon");
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#333333",
                            }}
                          >
                            {items?.contacttype}
                          </Link>
                        </td>
                        <td className="pt-3 ascHideForMobile HideForTablet">
                          <Link
                            to={`/contactlist/edit-contact/${items?.contactid}`}
                            onClick={() => {
                              window.localStorage.removeItem("clientaddname");
                              window.localStorage.removeItem("clientId2");
                              window.localStorage.removeItem("_tmpCon");
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#333333",
                            }}
                          >
                            {items?.accountmanagerfirstname}&nbsp;
                            {items?.accountmanagerlastname}
                          </Link>
                        </td>
                        <td className="pt-3 ascHideForMobile HideForTablet">
                          <Link
                            to={`/contactlist/edit-contact/${items?.contactid}`}
                            onClick={() => {
                              window.localStorage.removeItem("clientaddname");
                              window.localStorage.removeItem("clientId2");
                              window.localStorage.removeItem("_tmpCon");
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#333333",
                            }}
                          >
                            {items.lastActivity}
                          </Link>
                        </td>
                        <td className="pt-3" style={{ paddingRight: "30px" }}>
                          <img
                            // src=""
                            src={Kebab}
                            alt="kebab"
                            className={
                              rotate == index
                                ? "dot-rotate dot-rotated responsive-check"
                                : roleAccess === process.env.REACT_APP_IS_VIEWER
                                  ? "d-none"
                                  : "dot-rotate responsive-check"
                            }
                            style={{
                              // fontSize: "1.2rem",
                              cursor: "pointer",
                              position: "relative",
                            }}
                            onClick={(event) => {
                              event.preventDefault();
                              handleClick(event);
                              setFinalContact(items?.contactid);
                              setContactID(items?.contactid);
                              setRotate(index);
                              items?.contactclients &&
                              items?.contactclients.length > 0
                                ? setContactname3(true)
                                : setContactname3(false);
                            }}
                          />
                          <div style={{ position: "absolute" }}>
                            <MenuOptions
                              anchorEl={anchorEl}
                              open={contactID === items?.contactid}
                              history={history}
                              dispatch={dispatch}
                              Image1={Image1}
                              Image3={Image2}
                              Image4={Image3}
                              Image5={Image4}
                              Image6={Image5}
                              Image7={Kebab}
                              docUpload3={docUpload3}
                              selectDoc2={selectDoc2}
                              Bin={Bin}
                              // primaryColor={primaryColor}
                              handleClose={handleClose}
                              showModal={showModal}
                              setUlnlinkContact={setUlnlinkContact}
                              finalContact={finalContact}
                              setDeleteUser={setDeleteUser}
                              Menu={Menu}
                              MenuItem={MenuItem}
                              clkAssignTask={handleContactAssignTask}
                              AiFillPlusCircle={AiFillPlusCircle}
                              BiUnlink={BiUnlink}
                              hendleClick={hendleClick}
                              roleAccess={roleAccess}
                              unlinkContact={t("Unlink Contact")}
                              deleteContact={t("Delete Contact")}
                              addDoc={t("Add doc")}
                              assignTask={t("Assign Task")}
                              contactname2={
                                items?.contactclients &&
                                items?.contactclients[0]?.clientname
                              }
                              contactname3={contactname3}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                  {contactlist?.data?.length === 0 && (
                    <span className="noDataDisplay ps-3">
                      No data to display!
                      {/* {FetchTranslationList?.data?.data[94]?.translation} */}
                    </span>
                  )}
                </tbody>
              </table>
            </div>
            <div>
              <Row className="mb-3">
                <Col xs={6} xl={9}>
                  <p
                    className="fw-bold mt-3 "
                    style={{
                      fontSize: "20px",
                      color: "#333333",
                      display: "flex",
                    }}
                  >
                    <p
                      className="table-item mt-1"
                      style={{
                        fontWeight: 400,
                        fontSize: "clamp(10px, 0.729vw, 1vw)",
                      }}
                    >
                      {t("Items per page")}
                    </p>
                    <div
                      style={{
                        cursor: "pointer",
                        position: "relative",
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "5px",
                      }}
                      className="ms-4"
                    >
                      <p
                        className="margin-0"
                        style={{
                          fontSize: "clamp(10px, 0.729vw, 1vw)",
                          fontWeight: "bold",
                          color: "#333333",
                          flexGrow: "1",
                          textTransform: "capitalize",
                        }}
                        onClick={() => setShowMemberItem(!showMemberItem)}
                      >
                        {perPage}
                      </p>
                      <BsChevronDown
                        size={10}
                        style={{
                          flexGlow: "1",
                          color: "#333333",
                          cursor: "pointer",
                        }}
                        onClick={() => setShowMemberItem(!showMemberItem)}
                        className="down-arrow bi-paperclip ms-2 mt-1"
                      />
                      {showMemberItem && (
                        <div
                          className="drop-down-member-item d-flex align-items-end p-1"
                          ref={refTypeDropDownContainer}
                          id="lang-drop-down"
                        >
                          <div>
                            {[10, 20, 50]?.map((item, i) => {
                              return (
                                <div>
                                  <p
                                    key={i}
                                    className="margin-0 ms-2 pb-1"
                                    style={{
                                      opacity: 1,
                                      fontSize: "10px",
                                      fontWeight: "bold",
                                      color: `${
                                        item === perPage ? "#95A7C6" : "#333333"
                                      }`,
                                    }}
                                    onClick={() => {
                                      window.localStorage.setItem(
                                        "cl-pp",
                                        item,
                                      );
                                      setPerPage(item);
                                      setCurrentPage(0);
                                      setShowMemberItem(false);
                                      fetchContactList(item, query, 0);
                                    }}
                                  >
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                          <BsChevronDown
                            onClick={() => setShowMemberItem(!showMemberItem)}
                            size={10}
                            style={{
                              fontWeight: "bold",
                              flexGlow: "1",
                              color: "#333333",
                            }}
                            className="mb-1 ms-1 down-arrow down-arrow-rotate bi-paperclip"
                          />
                        </div>
                      )}
                    </div>
                  </p>
                </Col>
                <Col xs={6} xl={3} className="add-col-item">
                  <div className="table-filter-info">
                    <ReactPaginate
                      nextLabel=""
                      forcePage={currentPage}
                      disableInitialCallback={true}
                      onPageChange={PaginationChange}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={1}
                      pageCount={totalPages}
                      previousLabel=""
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="d-none"
                      nextClassName="d-none"
                      breakLabel="..."
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      containerClassName="app-paginations"
                      activeClassName="active"
                      renderOnZeroPageCount={null}
                    />
                  </div>
                </Col>
              </Row>
              {/* add button for mobile view start */}
              <Row className="p-4">
                <Col
                  onClick={() => {
                    dispatch(RemoveDocsClientById());
                    dispatch(EmptyProductPart());
                    window.localStorage.removeItem("clientaddname");
                    window.localStorage.removeItem("clientId2");
                    window.localStorage.removeItem("_tmpCon");
                    history.push("/add-contact");
                  }}
                  onMouseOver={() => setHovereff(true)}
                  onMouseOut={() => setHovereff(false)}
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "d-none"
                      : "d-flex add-member-btns d-none addButtonMobile"
                  }
                  style={{ borderRadius: "12px" }}
                >
                  {hovereff ? (
                    <Image height={17} width={21} src={AddIcon} />
                  ) : (
                    <Image height={17} width={21} src={Conthover} />
                  )}
                  <p className="add-member-text ms-3 mb-0">
                    {t("Add contact")}
                  </p>
                </Col>
              </Row>
              {/* add button for mobile view end */}
            </div>
          </div>
        </div>
      )}

      <Modal
        show={modal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        id="member-error-modal"
        className="modal_start"
      >
        <Modal.Body>
          <p
            style={{
              textAlign: "center",
              marginTop: "3rem",
            }}
            className="responsive-margin-bottom"
          >
            {deleteUser && (
              <span
                style={{
                  color: "#FC685A",
                  fontSize: "var(--responsive-font-18)",
                  display: "inline-block",
                }}
                className="responsive-margin-2"
              >
                {/* This data will be removed from the system */}
                {t("This data will be removed from the system")}
                <br />
                {/* and cannot be undone. */}
                {t("and cannot be undone.")}
              </span>
            )}
            {unlinkContact && (
              <span
                style={{
                  color: "#FC685A",
                  fontSize: "var(--responsive-font-18)",
                  display: "inline-block",
                }}
                className="responsive-margin-2"
              >
                {" "}
                You are unlinking this contact from the <br />
                company linked to and you are turning it <br /> into a Private
                Contact.
              </span>
            )}
            <p
              style={{
                marginTop: "1.5rem",
                fontSize: "var(--responsive-font-18)",
                fontWeight: "bold",
              }}
            >
              {/* Do you want to proceed? */}
              {t("Do you want to proceed?")}
            </p>
          </p>
          <Row
            style={{
              width: "80%",
              margin: "2rem auto 4rem auto",
              textAlign: "center",
            }}
          >
            <Col style={{ textAlign: "center" }}>
              <button
                className="cancel-btn"
                style={{
                  justifySelf: "center",
                  backgroundColor: "transparent",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  showModal(false);
                  setDeleteUser("");
                  setUlnlinkContact("");
                  setFinalContact("");
                }}
              >
                {/* No */}
                {t("No")}
              </button>
            </Col>
            <Col>
              <button
                className="cancel-btn invite-btn"
                style={{
                  backgroundColor: `#F76767`,
                  borderColor: `#F76767`,
                  color: "#FFFFFF",
                }}
                onClick={() => {
                  deleteUser && dispatch(DeleteContacts(deleteUser));
                  unlinkContact && dispatch(CreateUnlinkContact(unlinkContact));
                  showModal(false);
                  setIsDeletedContact(true);
                }}
              >
                {/* Yes */}
                {t("Yes")}
              </button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ContactList;
const MenuOptions = ({
  anchorEl,
  open,
  docUpload3,
  Image4,
  Image5,
  Image6,
  Bin,
  selectDoc2,
  // primaryColor,
  handleClose,
  showModal,
  setUlnlinkContact,
  finalContact,
  setDeleteUser,
  Menu,
  MenuItem,
  clkAssignTask,
  roleAccess,
  unlinkContact,
  deleteContact,
  addDoc,
  assignTask,
  contactname2,
  contactname3,
}) => {
  return (
    <Menu
      id="demo-positioned-menu"
      sx={{ boxShadow: "none" }}
      aria-labelledby="demo-positioned-button"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      onClick={() => {
        // e.preventDefault();
        // setRotate(!rotate);
      }}
      style={{
        boxShadow: "none",
      }}
      className="treedotboxshow"
    >
      <MenuItem
        onClick={() => {
          selectDoc2.current.click();
        }}
      >
        {" "}
        <input
          type="file"
          accept=".doc,.pdf,.xls,.xlsx,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          style={{ display: "none" }}
          ref={selectDoc2}
          onChange={(event) => {
            const fileUploaded = event.target.files[0];
            if (fileUploaded) {
              docUpload3(event, finalContact);
              handleClose();
            } else {
              return;
            }
          }}
        />
        <span style={{ position: "relative" }}>
          <img
            alt=""
            src={Image4}
            style={{
              width: "28px",
              height: "26px",
              marginRight: "1rem",
              marginTop: "1rem",
            }}
          />
        </span>
        <span
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            color: "#333333",
            marginTop: "1rem",
          }}
        >
          {addDoc}
        </span>
      </MenuItem>
      <MenuItem onClick={clkAssignTask}>
        {" "}
        <span style={{ position: "relative" }}>
          <img
            alt=""
            src={Image6}
            style={{
              width: "29px",
              height: "26px",
              marginRight: "1rem",
            }}
          />
        </span>
        <span
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            color: "#333333",
          }}
        >
          {assignTask}
        </span>
      </MenuItem>

      <MenuItem
        onClick={handleClose}
        className={contactname3 === true ? "" : "d-none"}
      >
        {" "}
        <span
          style={{
            position: "relative",
            marginRight: "1rem",
          }}
        >
          <img
            alt=""
            src={Image5}
            style={{
              width: "21px",
              height: "20px",
            }}
          />
        </span>
        <span
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            color: "#333333",
            marginLeft: "9px",
          }}
          onClick={() => {
            showModal(true);
            setUlnlinkContact(finalContact);
            setDeleteUser("");
          }}
        >
          {unlinkContact}
        </span>
      </MenuItem>
      <MenuItem onClick={handleClose}>
        {" "}
        <span style={{ position: "relative" }}>
          <img
            className={
              roleAccess === process.env.REACT_APP_IS_USER ? "d-none" : ""
            }
            alt=""
            src={Bin}
            style={{
              width: "20px",
              height: "22px",
              marginRight: "1rem",
            }}
          />
        </span>
        <span
          className={
            roleAccess === process.env.REACT_APP_IS_USER ? "d-none" : ""
          }
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            color: "#333333",
            marginLeft: "10px",
          }}
          onClick={(e) => {
            e.preventDefault();
            showModal(true);
            setDeleteUser(finalContact);
          }}
        >
          {deleteContact}
        </span>
      </MenuItem>
    </Menu>
  );
};
